import React, { useState } from "react";
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import GetCustomers from "../customers/get_customers";
import GetProducts from "../products/get_products";
import Button from "react-bootstrap/Button";

function NewSpecialPack(){
  // Order number
  var OrderNumber = 0;
  const setOrderNumber = () => {
    var OrderNumber_select = document.getElementById('Order_Number');
    OrderNumber = OrderNumber_select.value;
  }
  // Customer
  var Customer = 0;
  const Customers = GetCustomers();
  const handleCustomerChange = (event) => {
    Customer = event.value;
  }

  // Product
  var Product = 0;
  const Products = GetProducts("Pack");
  const handleProductChange = (event) => {
    var product_id = event.value;
    Product = Products.find(product => product.id == product_id);
  }

  // Quantity
  var Quantity = 0;
  const handleQuantityChange = () => {
    var Quantity_select = document.getElementById('Quantity');
    Quantity = Quantity_select.value;
  }

  // Product info
  var ProductCode = "";
  const handleProductCodeChange = () => {
    var ProductCode_select = document.getElementById('ProductCode');
    ProductCode = ProductCode_select.value;
  };

  var ProductStyle = "";
  const handleProductStyleChange = () => {
    var ProductStyle_select = document.getElementById('ProductStyle');
    ProductStyle = ProductStyle_select.value;
  };

  var ProductPackContents = "";
  const handleProductPackContentsChange = () => {
    var ProductPackContents_select = document.getElementById('ProductPackContents');
    ProductPackContents = ProductPackContents_select.value;
  };

  var ProductPackSize = 0;
  const handleProductPackSizeChange = () => {
    var ProductPackSize_select = document.getElementById('ProductPackSize');
    ProductPackSize = ProductPackSize_select.value;
  };

  // Building
  const Buildings = [
    { label: 'Warehouse', value: 'Warehouse' },
    { label: 'Shop', value: 'Shop' }
  ];

  var Building = "";
  const handleBuildingChange = (event) => {
    Building = event.value;
  };

  // Location
  var Location = "";
  const handleLocationChange = () => {
    var Location_select = document.getElementById('Location_ID');
    Location = Location_select.value;
  };

  var myData = "";
  const submitSpecial = async () => {
    myData = {
      stock: {
        stock_type_type: "StockFlooringPack",
        order_number: OrderNumber,
        customer_id: Customer,
        product_id: Product.id,
        quantity: Quantity,
        building: Building,
        location: Location
      },
      stock_type: {
        product_code: ProductCode,
        product_style: ProductStyle,
        product_pack_contents: ProductPackContents,
        product_pack_size: ProductPackSize
      }
    }

    const result = await fetch(import.meta.env.VITE_URL + '/specials', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(myData)
      })
      const resultInJson = await result.json()
  }

  return (

    <Form>

      <div className="row p-1">
        <div className="col"><h1>New Special Pack</h1></div>
      </div>
      <div>
        <Form.Text id="d" muted>
          Enter the Order Reference for this Special Item.
            <Form.Control
              type="string"
              min="0"
              placeholder="Order Reference"
              id="Order_Number"
              onChange={setOrderNumber}
              required
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Select the customer this special belongs to
            <Select
              options={Customers.map(opt => ({ label: opt.customerdisplayname, value: opt.id }))}
              onChange={event => handleCustomerChange(event)}
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Select the Product
            <Select
              options={Products.map(opt => ({ label: opt.name, value: opt.id}))}
              onChange={event => handleProductChange(event)}
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
            Enter the Quantity to add.
              <Form.Control
                type="number"
                min="0"
                step="1"
                placeholder="Quantity"
                id="Quantity"
                onChange={handleQuantityChange}
                required
              />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
            Enter the Product Code for this Product.
              <Form.Control
                type="string"
                placeholder="Product Code"
                id="ProductCode"
                onChange={handleProductCodeChange}
                required
              />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
            Enter the Product Style for this Product.
              <Form.Control
                type="string"
                placeholder="Product Style"
                id="ProductStyle"
                onChange={handleProductStyleChange}
                required
              />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
            Enter the Product Pack Contents for this Product.
              <Form.Control
                type="string"
                placeholder="Product Pack Contents"
                id="ProductPackContents"
                onChange={handleProductPackContentsChange}
                required
              />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Enter the Product Pack Size for this Product.
            <Form.Control
              type="number"
              min="0"
              step="0.01"
              placeholder="Pack Size M2"
              id="ProductPackSize"
              onChange={event => handleProductPackSizeChange(event)}
              required
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Select the Building the Special is located
            <Select
              options={Buildings}
              onChange={event => handleBuildingChange(event)}
            />
        </Form.Text>
      </div>
      <div>
        <Form.Text id="d" muted>
          Enter the Positional Location of the Special Item.
            <Form.Control
              type="string"
              id="Location_ID"
              placeholder="Positional Location"
              onChange={handleLocationChange}
            />
        </Form.Text>
      </div>
      <div className="mt-3">
        <Button type="submit" onClick={submitSpecial}>Submit form</Button>
      </div>

    </Form>

  )

}
export default NewSpecialPack
